export default {
  header_main: 'รับ/ปฏิเสธ สิ่งส่งตรวจ',
  patient_info: 'ข้อมูลผู้ป่วย',
  receiveLab: 'รับสิ่งส่งตรวจ',
  rejectLab: 'ปฏิเสธสิ่งส่งตรวจ',
  printOrderReport: 'พิมพ์ใบสั่งตรวจ',
  printSticker: 'พิมพ์สติ๊กเกอร์',
  Laboratory: 'ห้องปฏิบัติการ',
  OrderItemId: 'รหัสทดสอบ',
  OrderItemDesc: 'ชื่อการทดสอบ',
  cust_name: 'หน่วยงาน',
  OrderItemLaboratoryName: 'ห้องปฎิบัติการ',
  OrderId: 'เลขที่สั่งตรวจ',
  IdCard: 'เลขที่บัตรประชาชน',
  OrderItemSpecimenType: 'ชนิดสิ่งส่งตรวจ',
  OrderItemPrice: 'ราคา',
  is_get_back: 'ขอคืนตัวอย่าง',
  OrderItemUrgent: 'ขอผลด่วน',
  lab_item_status: 'สถานะ',
  lis_sid: 'LIS SID',
  OrderItemRemark: 'หมายเหตุ',
  PackageNo: 'เลขที่บรรจุภัณฑ์',
  PatientName: 'ชื่อ-นามสกุล',
  HN: 'HN',
  prefix: 'คำนำหน้า',
  fullname: 'ชื่อ-นามสกุล',
  firstname: 'ชื่อ',
  lastname: 'นามสกุล',
  birthday: 'วันเกิด',
  age: 'อายุ',
  sex: 'เพศ',
  user_created: 'User ที่ส่งตรวจ',
  date_created: 'วันที่สั่งตรวจ',
  date_send: 'วันที่ส่งตรวจ',
  date_receive: 'วันที่รับสิ่งส่งตรวจ',
  date_result: 'วันที่รายงานผล',
  collectionDate: 'วันที่เก็บสิ่งส่งตรวจ',
  status: 'สถานะ',
  hospitalLabNo: 'เลขที่สิ่งส่งตรวจ',
  paymentType: 'ประเภทการชำระเงิน',
  project: 'โครงการ',
  download: 'ใบรายงานผล',
  userDownload: 'ผู้ดาวน์โหลด',
  statusObj: {
    OP: 'ขอตรวจ',
    COLLECTION: 'รอรับสิ่งส่งตรวจ',
    RECEIVEDALL: 'รับสิ่งส่งตรวจเเล้ว',
    FIRSTAPPROVE: 'รายงานผล',
    LASTAPPROVE: 'อนุมัติผล',
    CA: 'ยกเลิกส่งตรวจ',
    labApprove: 'ส่งผลแล้ว',
    labNotApprove: 'รอส่งผล',
    labApprove2: 'รายงานผลแล้ว',
    labNotApprove2: 'รอรายงานผล'
  },
  errorMissingResult: 'กรุณารายงานผลก่อน',
  Previous: 'ย้อนกลับ',
  Approve: 'ส่งผล',
  next: 'ถัดไป',
  approveNext: 'ส่งผลและไปต่อ',
  ChkApprove: 'ผลการตรวจ',
  user_approve: 'ผู้อนุมัติ',
  labResult: 'รายงานผลการตรวจ',
  upload: 'ไฟล์แนบ',
  facility: 'Facility',
  labNo: 'Lab No.',
  patientName: 'ชื่อคนไข้',
  patientID: 'รหัสผู้ป่วย',
  hn: 'HN',
  remainingTAT: 'Remaining TAT',
  sampleID: 'Sample ID',
  result: 'ผลลลัพธ์',
  viewDetail: 'แสดงรายละเอียด',
  sendToNTIP: 'ส่งผลไปที่ NTIP',
  headerTitle: 'หน้าจอรายงานผล',
  receivedDate: 'วันที่รับวิ่งส่งตรวจ',
  registerDate: 'วันที่ลงทะเบียน',
  back: 'ย้อนกลับ',
  save: 'บันทึก',
  prinLabResult: 'พิมพ์ใบรายงานผล',
  cancelApprove: 'ยกเลิกรายงานผล',
  report: 'รายงานผล',
  approve: 'ยืนยันรายงานผล',
  firstApprove: 'First Approve',
  secondApprove: 'Second Approve',
  result_item_discription: 'Result Item Discription',
  result_value: 'Result Value',
  repeat: 'Repeat',
  flag: 'Flag',
  rejectHis: 'Reject History',
  is_reject: 'Reject',
  rejectDate: 'Reject Date',
  rejectLocation: 'สถานที่แจ้ง',
  rejectUser: 'ผู้แจ้ง',
  rejectNotifier: 'ผู้รับแจ้ง',
  rejectType: 'Reject Type',
  rejectReason: 'Reject Reason',
  date_speciment_receieve: 'วันที่รับสิ่งส่งตรวจ',
  resultValue: 'Result',
  dateTimeCreated: 'Create Date/Time',
  resultType: 'Result Type',
  unit: 'Unit',
  sub_category_desc: 'Sub Category',
  test_item_desc: 'Test Item',
  labStatus: 'สถานะการสั่งตรวจ',
  labApproveStatus: 'สถานะการส่งผล',
  labApproveStatus2: 'สถานะการรายงานผล',
  resultHistory: 'ประวัติการรายงานผล',
  approveHistory: 'ข้อมูลการรายงานผล',
  specimen_type_id: 'เลขที่สิ่งส่งตรวจ',
  order_id: 'เลขที่สั่งตรวจ',
  probePathogen: 'Probe/Pathogen',
  probe: 'Probe(s)',
  pathogen: 'Pathogen(s)',
  lab_specimen_type: 'ชนิดสิ่งส่งตรวจ',
  reference: 'Reference',
  dateDownload: 'วันที่ดาวน์โหลด',
  recalAttb: 'อัพเดทค่าอ้างอิง',
  errorMissingAgonistResult: 'กรุณารอกข้อมลให้ครบถ้วนก่อนดำเนินการ',
  addAgonist: 'Add Agonist',
  deleteAgonist: 'Delete Agonist',
  resultDesc: 'Result Item Description',
  enterPassword: 'กรุณากรอกรหัสผ่าน',
  diagnosis: 'Diagnosis',
  otherComment: 'Other Comments',
  comment: 'Comment',
  volumeUrine: 'Volume Urine (ml)',
  level_cd: 'Level',
  status_new: 'Status New',
  status_old: 'Status Old',
  employee_no: 'Employee No.',
  reason: 'หมายเหตุ',
  confirmCancelApprove: 'คุณต้องการยกเลิกรายงานผล ใช่หรือไม่?',
  dateTime: 'วันที่ - เวลา',
  request_by: 'แพทย์ผู้สั่งตรวจ',
  no: 'No.',
  description: 'Description',
  shortcut: 'Shortcut',
  resultLab: 'ผลการตรวจ',
  password: 'รหัสผ่าน',
  enterReason: 'กรุณาระบุเหตุผล',
  cancal: 'ยกเลิก',
  confirm: 'ยืนยัน',
  pleaseSaveChangesBeforeSwitchingCategory: 'กรุณาบันทึกการแก้ไขก่อน',
  saveError: 'บันทึกไม่สำเร็จ',
  agonistAlreadyAdded: 'ไม่สมารถเลือก Order Item ซ้ำได้',
  saveCommentSuccess: 'บันทึกความคิดเห็นเรียบร้อยแล้ว',
  pleaseInputCancelReason: 'กรุณาระบุเหตุผล',
  errorSelectApprove: 'กรุณาเลือก Order ที่ต้องการ Approve',
  search: 'ค้นหา',
  itemHist: 'ประวัติรายการตรวจ',
  searchData: 'ค้นหาข้อมูล',
  pleaseSelectCategory: 'กรุณาเลือกข้อมูลก่อน'
}
